import React, { useState } from "react";
import Button from "@material-ui/core/Button";

const CarerVoiceNotes = ({ onSubmit, textValue, onTextChange, updateVisitLoader }) => {
  const [isRecording, setIsRecording] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [audioChunks, setAudioChunks] = useState([]);
  const [hasRecording, setHasRecording] = useState(false);
  const [isSubmitMode, setIsSubmitMode] = useState(false); // Tracks if button is in Submit mode

  // Start Recording
  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream);

      recorder.ondataavailable = (event) => {
        setAudioChunks((prev) => [...prev, event.data]);
      };

      recorder.onstop = () => {
        setHasRecording(true);
      };

      setMediaRecorder(recorder);
      recorder.start();
      setIsRecording(true);
      setHasRecording(false);
      setAudioChunks([]);
      console.log("Recording started");
    } catch (error) {
      console.error("Error accessing microphone:", error);
      alert("Unable to access the microphone. Please check your permissions.");
    }
  };

  // Stop Recording
  const stopRecording = () => {
    if (mediaRecorder && mediaRecorder.state !== "inactive") {
      mediaRecorder.stop();
      setIsRecording(false);
      console.log("Recording stopped");

      // Release microphone
      const stream = mediaRecorder.stream;
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }
    }
  };

  // Send Recording
  const sendRecording = () => {
    if (audioChunks.length === 0) {
      console.warn("No audio data to send");
      alert("No recording found to send.");
      return;
    }
    const audioBlob = new Blob(audioChunks, { type: "audio/wav" });
    onSubmit(audioBlob);
    setAudioChunks([]);
    setHasRecording(false);
  };

  // Delete Recording
  const deleteRecording = () => {
    if (isRecording) {
      stopRecording();
    }
    setAudioChunks([]);
    setHasRecording(false);
  };

  // Handle Submit Text
  const handleSubmitText = () => {
    if (textValue.trim() === "") {
      alert("Please enter some text before submitting.");
      return;
    }
    onSubmit(null, false);
    setIsSubmitMode(false);
  };

  return (
    <div>
      {/* Textarea for Notes */}
      <textarea
        rows="4"
        placeholder="Type your notes here..."
        value={textValue}
        onChange={(e) => {
          onTextChange(e.target.value);
          setIsSubmitMode(true); // Switch to Submit mode when typing
        }}
        disabled={updateVisitLoader}
        style={{
          width: "100%",
          padding: "10px",
          marginBottom: "10px",
          borderRadius: "5px",
          border: "1px solid #ccc",
        }}
      />

      {/* Dynamic Button */}
      {!isRecording && !hasRecording && (
        <Button
          onClick={isSubmitMode ? handleSubmitText : startRecording} // Submit or Record
          className="scanning-btns"
          variant="contained"
          disableElevation
          disabled={updateVisitLoader}
          color={isSubmitMode ? "secondary" : "primary"} // Color based on mode
          startIcon={!isSubmitMode && <i className="fas fa-microphone"></i>} // Show mic icon in Record mode
          style={{
            cursor: "pointer",
            textTransform: "none",
          }}
        >
          {isSubmitMode ? "Submit" : "Record"} {/* Change label */}
        </Button>
      )}

      {/* Stop Recording Button */}
      {isRecording && (
        <Button
          onClick={stopRecording}
          variant="contained"
          disableElevation
          disabled={updateVisitLoader}
          style={{
            background: "#d71414",
            color: "white",
            fontWeight: "bold",
            padding: "10px 20px",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            textTransform: "none",
          }}
        >
          Stop Recording
        </Button>
      )}

      {/* Send and Delete Buttons */}
      {hasRecording && (
        <div style={{ marginTop: "10px" }}>
          <Button
            onClick={sendRecording}
            variant="contained"
            disableElevation
            disabled={updateVisitLoader}
            style={{
              background: "green",
              color: "white",
              fontWeight: "bold",
              padding: "10px 20px",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              textTransform: "none",
              marginRight: "10px",
            }}
          >
            Send Recording
          </Button>
          <div style={{ marginTop: "10px" }}>
            <Button
              onClick={deleteRecording}
              variant="contained"
              disableElevation
              disabled={updateVisitLoader}
              style={{
                background: "gray",
                color: "white",
                fontWeight: "bold",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                textTransform: "none",
              }}
            >
              Delete Recording
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CarerVoiceNotes;
